import { useEffect, useState } from 'react';
import { useTracker } from '../tracking/useTracker';
import { Step } from 'signup-constants/Step';
import { emailClientFromDomain, mailOptionsMapper } from './emailUtils';
import I18n from 'I18n';
import UIImage from 'UIComponents/image/UIImage';
import { AnimatedButton } from 'signup-components/styles/ButtonAnimations.styles';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
const GoToMailButton = ({
  email
}) => {
  const stepKey = Step.CodeVerification;
  const emailClient = emailClientFromDomain(email);
  const Tracker = useTracker();
  const [isSelected, setIsSelected] = useState(false);
  const onLoad = () => {
    if (emailClient) {
      Tracker.signupInteraction(`verification-shown-go-to-${emailClient}`);
    }
  };

  /* eslint-disable-next-line react-hooks/exhaustive-deps */
  useEffect(onLoad, []);
  const getEmailClientLink = () => {
    if (!emailClient) {
      return null;
    }
    const link = mailOptionsMapper[emailClient].link;
    if (link) {
      Tracker.click({
        message: 'click go to mail',
        linkLocation: `verify email button - ${emailClient}`
      });
    }
    return link;
  };
  const handleGoToEmail = () => {
    const link = getEmailClientLink();
    setIsSelected(true);
    const timeout = setTimeout(() => {
      setIsSelected(false);
    }, 500);
    if (link) {
      window.open(link, '_blank');
    }
    return () => {
      clearTimeout(timeout);
    };
  };
  if (!email || !emailClient) {
    return null;
  }
  const logo = mailOptionsMapper[emailClient].logo;
  return /*#__PURE__*/_jsx(View, {
    as: "div",
    marginBlockStart: "600",
    children: /*#__PURE__*/_jsx(AnimatedButton, {
      selected: isSelected,
      title: I18n.text(`views.${stepKey}.openEmailButton`),
      onClick: handleGoToEmail,
      children: /*#__PURE__*/_jsx(UIImage, {
        alt: "logo",
        responsive: false,
        src: logo
      })
    })
  });
};
export default GoToMailButton;